module.exports = __webpack_public_path__ + "img/FAB.8db02e7a.svg";